import { formatLocaleCurrencyWithMillionLabel } from "@/utils/formatUtils";
import type { CoverageLimitBase } from "./types";

export const formatCoverageLimit = (coverageLimit?: CoverageLimitBase): string | undefined => {
  return coverageLimit
    ? formatLocaleCurrencyWithMillionLabel(coverageLimit.health) +
        " / " +
        formatLocaleCurrencyWithMillionLabel(coverageLimit.property)
    : undefined;
};
